import React, { useState, useEffect } from 'react';
import api from '../../services/api';

interface Props {
  onFilterChange: (filters: { category_id: string; region_id: string }) => void;
}

interface Category {
  id: number;
  name_ar: string;
  slug: string;
}

interface Region {
  id: number;
  name_ar: string;
}

const selectStyle: React.CSSProperties = {
  background: '#F7F7F7',
  border: '1px solid #E3E3E3',
  borderRadius: 10,
  padding: '8px 12px',
  fontSize: 14,
  fontFamily: 'inherit',
  color: '#212121',
  outline: 'none',
  cursor: 'pointer',
  minWidth: 130,
};

const MapFilters: React.FC<Props> = ({ onFilterChange }) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [regions, setRegions] = useState<Region[]>([]);
  const [categoryId, setCategoryId] = useState('');
  const [regionId, setRegionId] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catRes, regRes] = await Promise.all([
          api.get('/categories'),
          api.get('/regions'),
        ]);
        setCategories(catRes.data.data || []);
        setRegions(regRes.data.data || []);
      } catch (err) {
        console.error('Error fetching filters:', err);
      }
    };
    fetchData();
  }, []);

  const handleCategoryChange = (val: string) => {
    setCategoryId(val);
    onFilterChange({ category_id: val, region_id: regionId });
  };

  const handleRegionChange = (val: string) => {
    setRegionId(val);
    onFilterChange({ category_id: categoryId, region_id: val });
  };

  const clearFilters = () => {
    setCategoryId('');
    setRegionId('');
    onFilterChange({ category_id: '', region_id: '' });
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 14,
        right: 14,
        // أعلى من طبقات وأزرار Leaflet (التي تصل إلى z-index 1000)
        zIndex: 1200,
        background: '#fff',
        borderRadius: 14,
        boxShadow: '0 6px 22px rgba(0,0,0,0.14)',
        border: '1px solid #ECECEC',
        padding: 12,
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        flexWrap: 'wrap',
        maxWidth: 'calc(100vw - 28px)',
      }}
    >
      <select
        value={categoryId}
        onChange={(e) => handleCategoryChange(e.target.value)}
        style={selectStyle}
      >
        <option value="">كل التصنيفات</option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.id}>{cat.name_ar}</option>
        ))}
      </select>

      <select
        value={regionId}
        onChange={(e) => handleRegionChange(e.target.value)}
        style={selectStyle}
      >
        <option value="">كل المناطق</option>
        {regions.map((reg) => (
          <option key={reg.id} value={reg.id}>{reg.name_ar}</option>
        ))}
      </select>

      {(categoryId || regionId) && (
        <button
          onClick={clearFilters}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#E53935',
            fontSize: 13,
            fontFamily: 'inherit',
            cursor: 'pointer',
            padding: '6px 8px',
            fontWeight: 600,
          }}
        >
          مسح الفلاتر
        </button>
      )}
    </div>
  );
};

export default MapFilters;
